jQuery(document).ready(function ($) {
    jQuery('#preaprobare-imm #preaprobare-next').on('click', function () {
        // Check the fields if they are empty
        var error = false;

        var idno = jQuery('#preaprobare-imm #idno').val();
        var administrator = jQuery('#preaprobare-imm #administrator').val();

        if (idno == '') {
            jQuery('#preaprobare-imm #idno').addClass('error');
            error = true;
        } else {
            jQuery('#preaprobare-imm #idno').removeClass('error');
        }

        if (administrator == '') {
            jQuery('#preaprobare-imm #administrator').addClass('error');
            error = true;
        } else {
            jQuery('#preaprobare-imm #administrator').removeClass('error');
        }

        if (error) {
            // alert('Va rugam completati toate campurile');
            return;
        }

        // Show next step
        jQuery('#preaprobare-imm .inner-step-1').hide();
        jQuery('#preaprobare-imm .inner-step-2').show();

        // Hide the conitnue button and show the complete button
        jQuery('#preaprobare-imm #preaprobare-next').hide();
        jQuery('#preaprobare-imm #preaprobare-imm-button').show();
    });

    jQuery('#preaprobare-imm #preaprobare-imm-button').on('click', async function (e) {

        e.preventDefault();

        // Check the fields if they are empty
        var error = false;

        var phone = jQuery('#preaprobare-imm #preaprobare-phone');
        var check = jQuery('#preaprobare-imm #preaprobare-check').is(':checked');

        var idno = jQuery('#preaprobare-imm #idno').val();
        var administrator = jQuery('#preaprobare-imm #administrator').val();

        if (idno == '' || idno && idno.length != 13) {
            jQuery('#preaprobare-imm #idno').addClass('error');
            jQuery('#preaprobare-imm #idno + .field-error').show();
            error = true;
        } else {
            jQuery('#preaprobare-imm #idno').removeClass('error');
            jQuery('#preaprobare-imm #idno + .field-error').hide();
        }

        if (administrator == '') {
            jQuery('#preaprobare-imm #administrator').addClass('error');
            jQuery('#preaprobare-imm #administrator + .field-error').show();
            error = true;
        } else {
            jQuery('#preaprobare-imm #administrator').removeClass('error');
            jQuery('#preaprobare-imm #administrator + .field-error').hide();
        }

        if (phone.val() == '' || phone.val().replace('+' + phone.data('country-code'), '').length < 6) {
            jQuery('#preaprobare-imm #preaprobare-phone').addClass('error');
            jQuery('#preaprobare-imm #preaprobare-phone').parent().parent().find('.field-error').show();
            error = true;
        } else {

            // Get the phone number from the input
            var phone = jQuery('#preaprobare-imm #preaprobare-phone');


            jQuery('#preaprobare-imm #preaprobare-phone').removeClass('error');
            jQuery('#preaprobare-imm #preaprobare-phone').parent().parent().find('.field-error').hide();
        }

        if (!check) {
            jQuery('#preaprobare-imm #preaprobare-check').addClass('error');
            jQuery('#preaprobare-imm #preaprobare-check + .field-error').show();
            error = true;
        } else {
            jQuery('#preaprobare-imm #preaprobare-check').removeClass('error');
            jQuery('#preaprobare-imm #preaprobare-check + .field-error').hide();
        }

        if (error) {
            // alert('Va rugam completati toate campurile');
            return;
        }

        var phoneCode = '+' + phone.attr('data-country-code');
        var phoneNumber = phone.val().replace(phoneCode, '');

        jQuery('#preaprobare-imm #preaprobare-imm-button .button-loader').show();

        const apiResponse = await saveLead({
            idno: idno,
            name: administrator,
            number: {
                countryCode: phoneCode,
                number: phoneNumber,
            },
        });

        var response = apiResponse.state === 'APPROVED' ? true : false;
        var value = {
            "12": parseFloat(apiResponse.result[0].amount).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, " "),
            "24": parseFloat(apiResponse.result[1].amount).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, " "),
            "36": parseFloat(apiResponse.result[2].amount).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, " "),
        };


        // Show next step
        jQuery('#preaprobare-imm .inner-step-1').hide();
        jQuery('#preaprobare-imm .inner-step-2').hide();
        jQuery(this).hide();

        // Show the right header
        jQuery('#preaprobare-imm .preaprobare-imm__header.default').hide();

        // Replace the preaprobare-success value
        jQuery('#preaprobare-imm .preaprobare-results .preaprobare-success .preaprobare-value-12').text(value['12'] + ' €');
        jQuery('#preaprobare-imm .preaprobare-results .preaprobare-success .preaprobare-value-24').text(value['24'] + ' €');
        jQuery('#preaprobare-imm .preaprobare-results .preaprobare-success .preaprobare-value-36').text(value['36'] + ' €');
        jQuery('#preaprobare-imm .preaprobare-results .preaprobare-success p.success-message').text(jQuery('#preaprobare-imm .preaprobare-results .preaprobare-success p.success-message').text().replace('{firma_ta}', apiResponse.companyName));

        window.dataLayer = window.dataLayer || [];

        if (response) {
            jQuery('#preaprobare-imm .preaprobare-imm__header.success').css('display', 'flex');
            jQuery('#preaprobare-imm .preaprobare-results .preaprobare-success').show();

            var eventSent = window.dataLayer.push({
                event: 'generate_prelead_pj'
            });

            // gtag('event', 'generate_prelead_pj');

        } else {
            jQuery('#preaprobare-imm .preaprobare-imm__header.error').css('display', 'flex');
            jQuery('#preaprobare-imm .preaprobare-results .preaprobare-error').show();

            var eventSent = window.dataLayer.push({
                event: 'generate_prelead_pj_neg'
            });

            // gtag('event', 'generate_prelead_pj_neg');
        }

        // Show the success message
    });

    jQuery('#reset-preaprobare-form').on('click', function () {

        // Empty the fields
        jQuery('#preaprobare-imm #idno').val('');
        jQuery('#preaprobare-imm #administrator').val('');
        jQuery('#preaprobare-imm #preaprobare-phone').val('');
        jQuery('#preaprobare-imm #preaprobare-check').prop('checked', false);

        // Reset the form
        jQuery('#preaprobare-imm .inner-step-1').show();
        jQuery('#preaprobare-imm .inner-step-2').show();
        jQuery('#preaprobare-imm #preaprobare-next').hide();
        jQuery('#preaprobare-imm #preaprobare-imm-button').hide();

        jQuery('#preaprobare-imm #preaprobare-imm-button').show();

        // Show the right header
        jQuery('#preaprobare-imm .preaprobare-imm__header.default').css('display', 'flex');
        jQuery('#preaprobare-imm .preaprobare-imm__header.error').hide();
        jQuery('#preaprobare-imm .preaprobare-imm__header.success').hide();

        jQuery('#preaprobare-imm .preaprobare-results .preaprobare-error').hide();

    });

    async function saveLead(data) {
        const apiUrl = 'https://api.app.fagura.com/api/marketing-and-sales/pre-assessment-pj';

        // Make the button loading
        jQuery('#preaprobare-imm #preaprobare-imm-button').attr('disabled', 'disabled');

        // Store the button text in a variable
        var buttonText = jQuery('#preaprobare-imm #preaprobare-imm-button span').text();

        // Change the button text
        jQuery('#preaprobare-imm #preaprobare-imm-button span').text(faguraData.loadingVerifyText);

        // Do fetch post request to the API with the user data
        const res = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
            .then(response => response.json())
            .then(data => {
                // console.log('Success:', data);
                jQuery('#preaprobare-imm #preaprobare-imm-button').removeAttr('disabled');
                jQuery('#preaprobare-imm #preaprobare-imm-button .button-loader').hide();

                if (data.name !== 'Error') {

                    return data;
                } else {
                    // alert('A intervenit o eroare. Va rugam incercati din nou');

                    // Add the error classes to the inputs
                    jQuery('#preaprobare-imm #idno').addClass('error');
                    jQuery('#preaprobare-imm #administrator').addClass('error');
                    jQuery('#preaprobare-imm #preaprobare-phone').addClass('error');

                    // Reset the button
                    jQuery('#preaprobare-imm #preaprobare-imm-button').removeAttr('disabled');

                    // Change the button text
                    jQuery('#preaprobare-imm #preaprobare-imm-button span').text(buttonText);
                }


            })
            .catch((error) => {
                console.error('Error:', error);
            });

        return res;
    }
});